import { Controller } from "@hotwired/stimulus"
import Honeybadger from "@honeybadger-io/js"

// Handles inline editing of trade-day requirement count
export default class extends Controller {
  static targets = ["count"]
  static values = {
    taskId: Number,
    tradeId: Number,
    date: String,
  }

  edit(event) {
    event.preventDefault()

    const countElement = this.countTarget
    const currentValue = parseInt(countElement.textContent) || 0

    // Replace with input
    const input = document.createElement("input")
    input.type = "number"
    input.min = "0"
    input.max = "99"
    input.value = currentValue
    input.className = "w-8 text-xs text-center border border-gray-300 rounded px-0.5 py-0"

    // Handle blur and enter
    input.addEventListener("blur", () => this.save(input))
    input.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        e.preventDefault()
        this.save(input)
      } else if (e.key === "Escape") {
        this.cancel(input, currentValue)
      }
    })

    countElement.replaceWith(input)
    input.focus()
    input.select()
  }

  save(input) {
    const newValue = parseInt(input.value) || 0

    if (newValue < 0 || newValue > 99) {
      this.cancel(input, 0)
      return
    }

    const csrfToken = document.head
      .querySelector('meta[name="csrf-token"]')
      ?.getAttribute("content")
    const url = `/plantafel/tasks/${this.taskIdValue}/trades/${this.tradeIdValue}/requirement`
    const data = {
      date: this.dateValue,
      required_count: newValue,
    }

    // Replace input with span immediately
    const span = document.createElement("span")
    span.dataset.plantafelTradeRequirementTarget = "count"
    span.className = "cursor-pointer hover:underline"
    span.dataset.action = "click->plantafel-trade-requirement#edit"
    span.textContent = newValue
    input.replaceWith(span)

    fetch(url, {
      method: "PATCH",
      credentials: "same-origin",
      headers: {
        "X-CSRF-Token": csrfToken,
        Accept: "text/vnd.turbo-stream.html",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then(async (response) => {
        const contentType = response.headers.get("Content-Type") || ""
        const html = await response.text()

        if (contentType.includes("text/vnd.turbo-stream.html")) {
          Turbo.renderStreamMessage(html)
        } else if (!response.ok) {
          Honeybadger.notify(`Failed to update trade-day requirement: ${response.status}`, {
            context: { level: "error", component: "plantafel-trade-requirement", action: "save" },
          })
        }
      })
      .catch((error) => {
        Honeybadger.notify(error, {
          context: { component: "plantafel-trade-requirement", action: "save" },
        })
      })
  }

  cancel(input, originalValue) {
    const span = document.createElement("span")
    span.dataset.plantafelTradeRequirementTarget = "count"
    span.className = "cursor-pointer hover:underline"
    span.dataset.action = "click->plantafel-trade-requirement#edit"
    span.textContent = originalValue
    input.replaceWith(span)
  }
}
